import * as FileSystemLegacy from 'expo-file-system/legacy';

export default FileSystemLegacy;
export * from 'expo-file-system/legacy';
